var _circle, _circle2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolFin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1777_2867)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.3333,
    cy: 24,
    r: 24,
    fill: "url(#paint0_linear_1777_2867)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1777_2867",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 48
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.3333,
    cy: 24,
    r: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1777_2867)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.3333,
    cy: 52.0005,
    r: 24,
    fill: "#48D7DA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.3333,
    cy: 52.0005,
    r: 18,
    fill: "#FDCF31"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.3333,
    cy: 52.0005,
    r: 12,
    fill: "#FD4D31"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1777_2867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3653 10.4607C23.7025 9.60335 24.9213 9.61949 25.2358 10.4854L26.1071 12.8848C26.2442 13.2624 26.5939 13.5212 26.995 13.5422L29.7307 13.6848C30.6459 13.7325 31.0202 14.8838 30.308 15.4605L28.3288 17.0633C28.0265 17.3081 27.8936 17.7059 27.988 18.0831L28.6594 20.7671C28.88 21.6489 27.905 22.3438 27.1434 21.8476L24.8791 20.3724C24.5473 20.1562 24.1192 20.1562 23.7874 20.3724L21.5231 21.8476C20.7616 22.3438 19.7865 21.6489 20.0071 20.7671L20.6785 18.0831C20.7729 17.7059 20.64 17.3081 20.3377 17.0633L18.354 15.4569C17.6424 14.8806 18.0154 13.7302 18.9298 13.6812L21.5248 13.5421C21.9158 13.5211 22.2585 13.2739 22.4019 12.9096L23.3653 10.4607Z",
    fill: "url(#paint1_linear_1777_2867)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1777_2867",
    x: -2.01807,
    y: -9.17322,
    width: 52.6982,
    height: 52.1864,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85098 0 0 0 0 0.670588 0 0 0 0 0.34902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1777_2867"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1777_2867",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1777_2867",
    x1: 22.0833,
    y1: 48,
    x2: 41.9583,
    y2: 6.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.166966,
    stopColor: "#7E1515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690044,
    stopColor: "#1A1055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1777_2867",
    x1: 27.3333,
    y1: 20,
    x2: 21.8333,
    y2: 10.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1777_2867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.333252)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolFin);
export default __webpack_public_path__ + "static/media/symbol-fin.909ab2a8391adb8ff9aef2e8686f5acb.svg";
export { ForwardRef as ReactComponent };